import { render } from "./personal.vue?vue&type=template&id=654f3e10&scoped=true"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"

import "./personal.vue?vue&type=style&index=0&id=654f3e10&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654f3e10"]])

export default __exports__